module.exports = "<p>\n  home works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/core/components/home/home.component.html
// module id = ../../../../../src/app/core/components/home/home.component.html
// module chunks = main